'use client';

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { type PrimedSupporterData, type SupporterQuery, primeSupporterData } from '../queries';
import { useSupporterQuery } from './base';
type SeedableSupporterBundleData = Partial<PrimedSupporterData>;
export const usePrimeSupporterQuery = supporterQuery => {
  const $ = _c(9);
  const queryClient = useQueryClient();
  const [isSupporterQueryCachePrimed, setIsSupporterQueryCachePrimed] = useState(false);
  const queryResult = useSupporterQuery(supporterQuery);
  const {
    data,
    isLoading,
    isFetching,
    isPending,
    isError
  } = queryResult;
  let t0;
  let t1;
  if ($[0] !== data || $[1] !== queryClient) {
    t0 = () => {
      if (!data) {
        setIsSupporterQueryCachePrimed(false);
        return;
      }
      primeSupporterData(queryClient, data);
      setIsSupporterQueryCachePrimed(true);
    };
    t1 = [data, queryClient];
    $[0] = data;
    $[1] = queryClient;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  const isShowingSkeletons = (isLoading || isFetching || isPending) && !data && !isError;
  const t2 = !isShowingSkeletons && isSupporterQueryCachePrimed;
  let t3;
  if ($[4] !== isShowingSkeletons || $[5] !== isSupporterQueryCachePrimed || $[6] !== queryResult || $[7] !== t2) {
    t3 = {
      ...queryResult,
      isShowingSkeletons,
      isSupporterQueryCachePrimed,
      isReadyToRenderChildren: t2
    };
    $[4] = isShowingSkeletons;
    $[5] = isSupporterQueryCachePrimed;
    $[6] = queryResult;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};